<template>
	<div>
		<!-- <mainTop></mainTop> -->
		<div class="tqhyMiddleBox" style="margin-top: 150px;">
			<div class="tqhyPageHead">
				<ul @mouseleave="tqhyHeadHoverIndex = selectedTqhyHeadHover">
					<li :class="{'tqhyHeadHover':tqhyHeadHoverIndex==0||selectedTqhyHeadHover==0}"
							@click="changeWeb(0)"
							@mouseover="tqhyHeadHoverIndex = 0">会议首页</li>
					<li :class="{'tqhyHeadHover':tqhyHeadHoverIndex==1||selectedTqhyHeadHover==1}"
							@click="changeWeb(1)"
							@mouseover="tqhyHeadHoverIndex = 1">同期会议</li>
					<li :class="{'tqhyHeadHover':tqhyHeadHoverIndex==2||selectedTqhyHeadHover==2}"
							@click="changeWeb(2)"
							@mouseover="tqhyHeadHoverIndex = 2">会议嘉宾</li>
					<li :class="{'tqhyHeadHover':tqhyHeadHoverIndex==3||selectedTqhyHeadHover==3}"
							@click="changeWeb(3)"
							@mouseover="tqhyHeadHoverIndex = 3">视频回放</li>
				</ul>
			</div>
			<div class="tqhyPage" style="margin-bottom: 35px;">
				<div class="tqhyContent" @mouseleave="moduleHoverIndex = selectedModuleHover">
					<div v-for="(item,index) in meeting.rows" class="tqhyModule" :class="{'moduleHover':moduleHoverIndex==index||selectedModuleHover==index}" @click="selectedModuleHover=index"
							@mouseover="moduleHoverIndex = index" style="width: 1140px;height: 320px;">
						<div style="width: 377px;height: 262px;float: left;">
							<img :src="baseUrl()+item.image" style="width: 100%;height: 100%;" alt=""></div>
						<div style="color: #150e52;width: 640px;margin-left:390px;margin-top: 18px;text-align: left;">
							<div style="font-size: 19px;font-weight: 600;height: 23px; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
							font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;">
							{{ item.name }}</div>
							<div style="height: 112px; font-size: 18px;line-height: 30px;
							font-family: Adobe 黑体 Std R;margin-top: 23px;letter-spacing: 1px;overflow: hidden;">
							<div style="height: 30px;">
								开始时间：{{ item.startTime }}
							</div>
							<div  style="height: 30px;">
								结束时间：{{ item.endTime }}
							</div>
							<div  style="height: 30px;">
								特邀讲师：{{ item.guestName }}
							</div>
							</div>
							<a @click="getQrCode(item.qrCode)"  style="text-decoration: none;color: #150e52;cursor: pointer;">
							<div style="position: absolute;left:420px;bottom: 31px;border: 2px solid #150e52;width: 115px;
								text-align: center;height: 35px;line-height: 35px;font-size: 20px;font-weight: 600;"
								v-if="checkStatus"
								>
                视频回放
							</div>
							</a>
						</div>
					</div>
				</div>
				<div style="height: 60px;float: right;margin-top: 20px;" v-if="total">
					 <el-pagination
					      @size-change="handleSizeChange"
					      @current-change="handleCurrentChange"
					      :current-page.sync="currentPage"
					      :page-size="5"
					      layout="prev, pager, next"
					      :total="this.total">
					    </el-pagination>
						<div class="el-pagination__jump">
							共{{totalPageSize}}页，到第<div class="el-input el-pagination__editor is-in-pagination">
								<input type="text" class="inputNum" v-model="pageInputNum"
								oninput="value=value.replace(/[^\d]/g,'');
								if(value<=0)value='';if(value.length > 1 && value.substr(0,1) ==0 && value.substr(1,1) !='.'){
								value= value.substr(1,1)}" >
						</div>
						页
						</div>

					<button class="button1" style=""  @click="changePage">确定</button>
				</div>
			</div>
		</div>
		<el-dialog

		  :visible.sync="centerDialogVisible"
		  width="810px"

		  center>
		  <div class="dialogLeft" style="">
			  <!-- <img src="../images/dialogBg.png" style="width: 100%;height: 100%;" alt=""> -->
			  <div style="text-align: center;margin-top: 130px;">
				  <img src="../images/12.png" style="width: 60px;" alt="">
			  </div>
			  <div style="margin-left: 10px;margin-top: 60px;">
				  <img src="../images/diaText.png" alt="">
			  </div>

			  </div>
			<div style="text-align: center;margin-top: 105px;">
				<img :src="this.QrCode" style="width: 190px;height: 190px;" alt="">
				<div style="font-size: 28px;color: #201b1b;margin-top: 20px;letter-spacing: 2px;">
					扫码 <div style="font-weight: 600;margin-top: -1px;margin: 0px 5px; display: inline-block;">—</div> 进入直播间
				</div>
			</div>

		</el-dialog>
		<!-- <mainBottom></mainBottom> -->
	</div>
</template>

<script>
	import mainTop from '../components/mainTop.vue'
	import mainBottom from '../components/mainBottom.vue'
	import axios from 'axios';
  import {baseUrl} from "@/components";
	export default {
	  components: {
		  mainTop,
		  mainBottom
	   },
	   data(){
		   return{
			   tqhyHeadHoverIndex:1,
			   selectedTqhyHeadHover:1,
			   pageSize: 16,
			   totalCount: 1,
			   totalPageSize:1,
			   pageInputNum:'',
			   currentPage: 1,
			   moduleHoverIndex:-1,
			   selectedModuleHover:-1,
			   meeting:'',
			   total:5,
			   currentDateTime:'',
			   checkStatus:['视频回放','视频回放','视频回放','视频回放','视频回放'],
			   centerDialogVisible: false,
			   QrCode:'',

			   };
			},
		created(){
			this.getMeeting(1)
		},
		methods:{
      baseUrl,
			getQrCode(qrcode){
				this.centerDialogVisible=true
				this.QrCode='https://admin.nxhzy.cn/prod-api'+ qrcode

			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange() {
			//    this.contentPerPage.pn=this.currentPage;
			//    contentList(this.contentPerPage).then(response => {
			//            this.contentPerPageList = response.data;
			//          });
				this.getMeeting(this.currentPage)
			},
			changeFirstPage(){
				this.currentPage=1;
				this.handleCurrentChange();
			},
			changeLastPage(){
				this.currentPage=this.totalPageSize;
				this.handleCurrentChange();
			},
			getTotalPageSize(){
				this.totalPageSize=this.totalCount/this.pageSize
			},
			changePage(){
				this.currentPage=parseInt(this.pageInputNum);
				this.handleCurrentChange();
			},
			changeWeb(num){
				this.selectedTqhyHeadHover=1
				switch (num) {
					case 0:
						this.$router.push('/site/hysy')
						break;
					case 1:
						this.$router.push('/site/tqhy')
						break;
					case 2:
						this.$router.push('/site/hyjb')
						break;
					case 3:
						this.$router.push('/site/sphf')
						break;
					default:
						break;
				}

			},
			getMeeting(pnum){
				let add=[]
				axios.get('/web/meeting/list',{
					params:{
						pageSize:5,
						pageNum:pnum,
					}
				}).then((res)=>{
                    this.meeting=res.data
					this.total=res.data.total
					this.totalPageSize=Math.ceil(this.total/5)

					if (this.meeting.rows) {
						for (let index = 0; index < this.meeting.rows.length; index++) {
							const nowdate = new Date();
							nowdate = nowdate.getTime();
							const sdate = new Date(this.meeting.rows[index].startTime);
							sdate = sdate.getTime();
							const edate = new Date(this.meeting.rows[index].endTime);
							edate = edate.getTime();
							if(nowdate>sdate&&nowdate<edate){
								add.push('正在直播')
							}else if(nowdate<sdate){
								add.push('即将开播')
							}
							else{
								add.push('视频回放')
							}
						}
					}

                })
				this.checkStatus=add
				// console.log(this.checkStatus);
			}
		},
		}
</script>

<style>
	.tqhyMiddleBox{
		width: 100%;
		min-width: 1700px;
		background-color: #f7f7f7;
	}
	.tqhyPageHead{
		width: 1140px;
		min-width: 1140px;
		height: 60px;
		margin: auto;
		margin-top: 33px;
	}
	.tqhyPageHead ul{
		list-style: none;
		text-align: center;
		height: 60px;
		width: 1140px;
	}
	.tqhyHeadHover{
		background-color: #150e52 !important;
		color: #fff !important;
	}
	.tqhyPageHead ul li:nth-child(-n+3){
		width: 195px;
		height: 50px;
		margin: auto;
		line-height: 50px;
		float: left;
		margin-right:114px;
		font-size: 22px;
		color: #150e52;
		font-weight: 600;
		text-align: center;
		border-radius: 30px;
		border: 2px solid #150e52;
	}
	.tqhyPageHead ul li:nth-child(4){
		width: 195px;
		height: 50px;
		line-height: 50px;
		float: left;
		margin: auto;
		border-radius: 30px;
		border: 2px solid #150e52;
		font-size: 22px;
		color: #150e52;
		font-weight: 600;
		text-align: center;
	}

	.el-pagination{
		  display: inline-block;
		  float: left;
	  }
	  .el-pager li,.el-pager li.active+li {
		border: 2px solid #8c8c8c !important;
		margin-right: 12px !important;
		color: #8c8c8c;
		border-radius: 7px;
		height: 35px !important;
		font-size: 18px !important;
		line-height: 33px !important;
		width: 26px;
		font-family: Arial, Helvetica, sans-serif;

	  }
	   .el-pager li:hover{
		   color: #8c8c8c !important;
	   }
	  .el-pager li{
		  background-color: #f7f7f7 !important;
	  }
	  .btn-next{
		  padding-left: 2px !important;
		  background-color: #f7f7f7 !important;
	  }

	   .btn-prev{
		    background-color: #f7f7f7 !important;
	   }
	  .btn-prev .el-icon-arrow-left:before,.btn-next .el-icon-arrow-right:before {
	      border: 2px solid #8c8c8c;
	      height: 31px;
	      display: flex;
	      width: 26px;
	      border-radius: 7px;
	      text-align: center;
	      margin: auto;
	      line-height: 32px;
	      font-size: 24px;
	      padding-left: 5px;
	      font-weight: 700;
		  color: #8c8c8c;
	  }
	  .el-icon-arrow-right:before {
	      content: "\E6E0";
	      margin-left: -12px;
	  }

	  .button1{
	  		  width: 67px;
	  		  height: 36px;
	  		  font-size: 16px;
	  		  border-radius: 7px;
	  		  color: #ffffff;
	  		  background-color: #150e52;
	  		  font-weight: 700;
	  		  margin-left:12px;
	  		  float: left;
	  		  margin-top: 2px;
			  border: 0px;
	  }
	  .el-pager li.active {
	      color: white !important;
	      cursor: default;
	      background-color: #150e52 !important;
	      border: 1px !important;
	      /* text-align: center; */
	      line-height: 36px !important;

	  }
	  .el-pagination__jump {
	      margin-left: 3px !important;
	      font-weight: 600 !important;
	      color: #8c8c8c !important;
	      font-size: 17px;
		  float: left;
		  margin-top: 1px;
	  }
	  .inputNum{
		  width: 33px !important;
		  height: 33px !important;
		  border: 2px solid #8c8c8c !important;
		  border-radius: 7px;
		  border: 0;
		  outline: none;
		  text-align: center;
		  background-color: #f7f7f7;
	  }
	.el-pager li.btn-quicknext,.el-pager li.btn-quickprev{
		border:0px !important;
		color: #8c8c8c !important;
	}
	.tqhyPage{
		width: 1140px;
		min-width: 1140px;
		margin: auto;
		margin-top: 35px;
		height: 1768px;
	}
	.liHover{
		color: #fff !important;
		background-color: #150e52 !important;
		border-radius: 15px;
	}
	.tqhyContent{
		width: 1140px;
		min-width: 1140px;
		margin-top: 30px;
		height: 1698px;
		overflow: hidden;
	}
	.tqhyModule{
		width: 1080px;
		height: 262px;
		/* background-color: #fff; */
		padding: 30px 30px;
		position: relative;
		margin-bottom: 22px;
	}
	.moduleHover{
		background-color: #fff !important;
	}
</style>
